// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"GQ-z","categoryName":"HQ-z","categoryNameSearchHeader":"IQ-z","categoryContent":"JQ-z","bottomAligned":"KQ-z","image":"LQ-z","imageNoBackground":"MQ-z"};